import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator } from '../../../../helpers/cell-validators'

export const validateMaterialWidth: CellValidator = (record, token: GlobalToken) => {
    const materialWidth = record.calculated?.materialWidth
    const machineName = record.machine?.name

    if (materialWidth === undefined) {
        return null
    }

    if (materialWidth < 150 || materialWidth > 428) {
        return {
            message: 'Ширина должна быть от 150 до 428 мм',
            bgColor: token.colorErrorBg,
            color: token.colorErrorText || token.colorError,
        }
    }

    if (machineName && machineName.toLowerCase().includes('bobst') && materialWidth > 368) {
        return {
            message: 'Для BOBST ширина не должна превышать 368 мм',
            bgColor: token.colorErrorBg,
            color: token.colorErrorText || token.colorError,
        }
    }

    if (machineName && machineName.toLowerCase().includes('durst') && materialWidth > 350) {
        return {
            message: 'Для Durst ширина не должна превышать 350 мм',
            bgColor: token.colorErrorBg,
            color: token.colorErrorText || token.colorError,
        }
    }

    return null
}

